export const user = {
  get: "https://randomuser.me/api/",
};
